import { useQuery } from 'react-query'
import { DetailPaginatedRequest } from '../../../core/interfaces'
import { getCustomerAccompaniments } from '../../customers'

export default function useCustomerAccompaniments(
  query: DetailPaginatedRequest
) {
  const { data, error, isLoading } = useQuery(
    ['customerAccompaniments', query],
    () => getCustomerAccompaniments(query)
  )
  return { data, error, isLoading }
}
